// eslint-disable-next-line no-unused-vars
import { Plugin } from "./Main";
import {ITool} from "../../../sdk/plugins/interfaces";
import {DashboardPage} from "./DashboardPage";
import {app, globalMatrix, matrixsdk, ml} from "../../../sdk/client";
import {UIToolsConstants} from "../../../sdk/ui";

export class Tool implements ITool {

    /** callback to show or hide the menu for a selected item or folder
     *
     * */
    showMenu(itemId:string) {
        let itemRef = ml.Item.parseRef(itemId);

        return( itemRef.isFolder && Tool.canBeDisplayed(itemRef.type));
    }

    static canBeDisplayed(cat:string):boolean
    {
        return ml.LabelTools.getLabelDefinitions( [cat]).length != 0;
    }

    /** callback when user executes the custom the menu entry added to items or folders
     *
     * */
    async menuClicked(itemId:string) {

        let itemRef = ml.Item.parseRef(itemId);

        /* Insert code here */
        // We should create a popup then render the dashboard in it
        let project = await matrixsdk.openCurrentProjectFromSession();
        // TODO: It is a bummer to re-create project and projectStorage here when our master IPlugin
        // has them. Probably we would benefit from making the master plugin object from which these
        // tools, dashboards, whatever are created available to the children.


        /* Insert code here */
       // We should create a popup then render the dashboard in it
        const dashboard = new DashboardPage(project, globalMatrix.projectStorage,true,itemId);
        let ui = dashboard.render();
        let dlg = $("<div></div>").appendTo("body");
        let dialogTitle = Plugin.config.dashboard.title + " for " + itemId;

        ml.UI.showDialog(dlg, dialogTitle, ui, $(document).width() * 0.90, app.itemForm.height() * 0.90,
            [],
            UIToolsConstants.Scroll.Vertical,
            true,
            true,
            () => {
                dlg.remove();
            },
            () => {
                dashboard.installCopyButtons(dialogTitle);
                //Code to load Dashboard here
                dashboard.SelectionChanged({cat:itemRef.type,folder:itemId, hideNoLabel:false})
            },
            () => { dashboard.onResize() }
        );

    }
}
